import React from "react";
import { observer } from "mobx-react";

const RichLiteral = ({ title, text }) => (
  <div className="input-field">
    <label>{title}</label>
    <div style={{ marginTop: "-5px", marginLeft: 8 }}>
      {text !== null && <span dangerouslySetInnerHTML={{ __html: text }} />}
    </div>
  </div>
);

export default observer(RichLiteral);
